<div [style.padding]="dialog ? '0' : '0 24px 64px 24px'">
    <kiene-page-header *ngIf="!dialog" [ueberschrift]="ueberschrift"></kiene-page-header>

    <div *ngIf="isLoading" class="bemerkung-loading">
        <span>Lade Tier...</span>
    </div>

    <div *ngIf="!isLoading" class="bemerkung-content">
        <h3 class="bemerkung-title">Ohrmarke {{ this.tier?.ohrmarke_notnull }}</h3>

        <div class="bemerkung-body">
            <h4>Bemerkungen</h4>

            <div class="bemerkung-input-row">
                <kiene-autocomplete
                    class="bemerkung-input"
                    #bemerkungenAutocomplete
                    (elementSelected)="addBemerkung($event)"
                    [clearAfterSelect]="true"
                    [genericApiUrl]="bemerkungenAutocompleteUrl"
                    [placeholder]="'Bemerkung hinzufügen'"
                    [displayFields]="['bemerkung']"
                    [showClear]="false"
                    [focus]="false"
                    [noPaddingNoMargin]="true"
                >
                </kiene-autocomplete>
                <button class="bemerkung-add-btn" mat-icon-button color="accent" (click)="add()">
                    <mat-icon>add</mat-icon>
                </button>
            </div>

            <div class="bemerkung-empty" *ngIf="tier?.bemerkungen?.length === 0">
                <mat-hint>- keine Bemerkungen hinterlegt -</mat-hint>
            </div>

            <div class="bemerkung-list-wrap" *ngIf="tier?.bemerkungen?.length > 0">
                <table aria-label="" class="bemerkung-table">
                    <thead>
                        <th></th>
                        <th></th>
                        <th></th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let bemerkung of tier?.bemerkungen">
                            <td>{{ bemerkung?.bemerkung }}</td>
                            <td>{{ bemerkung?.vorname?.substring(0, 1) }}. {{ bemerkung?.nachname }}</td>
                            <td>{{ bemerkung?.erstellt | date: "dd.MM.YY HH:mm" }}</td>
                            <td>
                                <button class="bemerkung-delete-btn" mat-icon-button color="accent" (click)="deleteBemerkung(bemerkung)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div
            [style]="
                dialog
                    ? 'position: sticky; bottom: 0; background-color: white; padding: 12px 0 0 0;'
                    : 'padding-top: 24px'
            "
            class="one-row bemerkung-actions"
            [style.justify-content]="dialog ? 'space-between' : 'center'"
        >
            <button
                *ngIf="!dialog"
                color="accent"
                mat-flat-button
                data-cy="bemerkung-save"
                (click)="bemerkungenHinzufuegen()"
                [disabled]="isSaving"
            >
                Speichern
            </button>
            <ng-content select="[additional-actions]"></ng-content>
        </div>
    </div>
</div>
